import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAuthenticationService, ILoggingService, PortfolioInfo, PortfoliosServiceClient } from 'clientportalshared';
import { portfolioInfosThunkPayload } from '../../constants';
import container from '@ioc';
import appConfig from '@src/app/config/appConfig';
import { IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import { GetPortfolioInfosRequest } from './types';

export const getDashboardAsync = createAsyncThunk<PortfolioInfo, GetPortfolioInfosRequest>(
  portfolioInfosThunkPayload,
  async (payload: GetPortfolioInfosRequest) => {
    try {
      const authService = container.get<IAuthenticationService>(IAuthenticationService$);
      const loggingService = container.get<ILoggingService>(ILoggingService$);
      const portfoliosClient = new PortfoliosServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);
      return await portfoliosClient.getPortfolioInfoDetailsAsync(payload.includeValueOverTime, payload.clientPortfolios);
    } catch (e) {
      return {} as PortfolioInfo;
    }
  }
);
